import { CursorPaginatedResponseSchema } from 'notable-common';
import { z } from 'zod';
/**
 * One voice assistant: who owns it, what it is called, and which configuration it answers with.
 *
 * The configuration itself — prompts, voice, tools, timeouts — is the definition this points at,
 * and is read separately.
 */
export const AssistantSchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    name: z.string().describe('Unique within the organization.'),
    description: z.string().nullable(),
    organizationId: z.uuid(),
    practiceId: z.uuid().describe('The practice the assistant answers for.'),
    liveDefinitionId: z
        .uuid()
        .nullable()
        .describe('The configuration calls reaching this assistant now are answered with. A call records the ' +
        'definition that answered it, which may be an earlier one.'),
});
/** One page of assistants, in the envelope every cursor-paginated route returns. */
export const AssistantListResponseSchema = CursorPaginatedResponseSchema(AssistantSchema);
//# sourceMappingURL=read.js.map